export default __webpack_public_path__ + "static/media/description-place.9c4999b2.png";